import { Controller } from "@hotwired/stimulus"

const openDropdowns = new Set()

export default class extends Controller {
  static targets = ["menu"]
  static values = { fixed: { type: Boolean, default: false } }

  connect() {
    openDropdowns.add(this)
    if (this.fixedValue) {
      this.boundClose = () => this.close()
      window.addEventListener("scroll", this.boundClose, true)
      window.addEventListener("resize", this.boundClose)
    }
  }

  disconnect() {
    openDropdowns.delete(this)
    if (this.boundClose) {
      window.removeEventListener("scroll", this.boundClose, true)
      window.removeEventListener("resize", this.boundClose)
    }
  }

  toggle(event) {
    event.stopPropagation()
    const isCurrentlyClosed = this.menuTarget.classList.contains("hidden")

    if (isCurrentlyClosed) {
      this.closeAll()
      this.open(event.currentTarget)
    } else {
      this.close()
    }
  }

  open(trigger) {
    if (this.fixedValue) {
      this.positionMenu(trigger)
      this.elevateParent()
    }
    this.menuTarget.classList.remove("hidden")
  }

  close() {
    if (this.menuTarget.classList.contains("hidden")) return
    this.menuTarget.classList.add("hidden")
    if (this.fixedValue) this.resetParent()
  }

  hide(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }

  closeAll() {
    openDropdowns.forEach(dropdown => {
      if (dropdown !== this) dropdown.close()
    })
  }

  positionMenu(trigger) {
    const rect = trigger.getBoundingClientRect()
    this.menuTarget.style.top = `${rect.bottom + 4}px`
    this.menuTarget.style.right = `${window.innerWidth - rect.right}px`
    this.menuTarget.style.left = "auto"
  }

  elevateParent() {
    const parent = this.element.parentElement
    if (!parent) return
    this.originalParentZIndex = parent.style.zIndex
    parent.style.zIndex = "60"
  }

  resetParent() {
    const parent = this.element.parentElement
    if (!parent || this.originalParentZIndex === undefined) return
    parent.style.zIndex = this.originalParentZIndex
    this.originalParentZIndex = undefined
  }
}
